/**
 * Nastaveí odkazy ve fromátu <a href="#..." data-animated-anchor>...</a> tak aby se
 * po kliknutní na ně provedla animace na odpovídající kotvu
 */

export function run()
{
    document.querySelectorAll('a[data-animated-anchor]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();

            let target = document.querySelector(this.getAttribute('href'));

            if(target !== null) {
                target.scrollIntoView({
                    behavior: 'smooth'
                });
            }
        });
    });
}

